module.exports = __webpack_public_path__ + "img/user.90132cf1.png";